import React from 'react';
import PropTypes from 'prop-types';
import { Col, Button } from 'antd';
import CheckIcon from 'components/Icons/CheckIcon';

const SectionHeader = ({ filteredApprovedProposals, bulkLoading, handleSignedSeen }) => {
  return (
    <div className="page-header">
      <Col className="page-title-wrapper">
        <div className="page-title-conatiner">
          <h3 className="page-title">New Signed Proposals 🎉</h3>
        </div>
      </Col>
      <Col className="button-wrapper">
        <Button
          className="medium-btn acknowledge-button"
          disabled={bulkLoading}
          onClick={(e) => {
            e.stopPropagation();
            filteredApprovedProposals.forEach(({ pid }) => {
              handleSignedSeen(pid);
            });
          }}>
          <CheckIcon />
          <span className="above-md">I've Seen All</span>
          <span className="below-md">Seen</span>
        </Button>
      </Col>
    </div>
  );
};

SectionHeader.propTypes = {
  filteredApprovedProposals: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  bulkLoading: PropTypes.bool,
  handleSignedSeen: PropTypes.func.isRequired,
};

export default SectionHeader;
